export const styles = (theme) => ({
  inputGroupContainer: {
    display: "flex",
    alignItems: "center",
    "& > *:not(:last-child)": {
      marginRight: 16,
    },
  },
});
